export default "__VITE_ASSET__genZ03PK__"